/* SEVENTYSEVEN.DC — Theme JS */
(function(){
  'use strict';

  function money(cents){
    return (cents/100).toLocaleString('en-EG',{minimumFractionDigits:0,maximumFractionDigits:0}) + ' EGP';
  }

  // What the customer pays for the products only: the lines after their
  // discounts, minus any cart-level discount. Delivery and any fees are never
  // part of it. Shopify's free-delivery rule (orders of 2,700 EGP and up) is
  // checked against this same number, so the bar and the checkout agree.
  function itemsTotal(cart){
    var s = 0;
    (cart.items || []).forEach(function(i){ s += (i.final_line_price || 0); });
    (cart.cart_level_discount_applications || []).forEach(function(d){ s -= (d.total_allocated_amount || 0); });
    return Math.max(0, s);
  }

  function esc(s){
    return String(s == null ? '' : s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }

  function notify(msg){
    var n = document.getElementById('notif');
    if(!n) return;
    n.textContent = msg;
    n.classList.add('show');
    clearTimeout(window._notifT);
    window._notifT = setTimeout(function(){n.classList.remove('show')},2800);
  }

  var cartSeq = 0;
  var cartBusy = false;

  function setBusy(on){
    cartBusy = on;
    var dr = document.getElementById('cartDrawer');
    if(dr) dr.classList.toggle('busy', on);
  }

  // ── BUNDLE SLOTS ─────────────────────────────────
  // Bundle products carry a custom.bundle_slots metafield. Every slot must be
  // chosen before the product can be added, and the choices ride along as line
  // item properties so they appear on the order and in 77DC HQ.
  function bundleSelects(){
    return Array.prototype.slice.call(document.querySelectorAll('#bundleSlots [data-bslot]'));
  }

  function collectBundleProps(){
    var sels = bundleSelects();
    if(!sels.length) return { ok: true, props: null };
    var props = {}, ok = true, firstEmpty = null;
    sels.forEach(function(sel){
      if(!sel.value){
        ok = false;
        sel.classList.add('bslot-error');
        if(!firstEmpty) firstEmpty = sel;
      } else {
        sel.classList.remove('bslot-error');
        props[sel.name.replace(/^properties\[/, '').replace(/\]$/, '')] = sel.value;
      }
    });
    if(!ok){
      if(firstEmpty){
        firstEmpty.scrollIntoView({ behavior: 'smooth', block: 'center' });
        try { firstEmpty.focus({ preventScroll: true }); } catch(e){ firstEmpty.focus(); }
      }
      notify('Pick every piece in the bundle first');
    }
    return { ok: ok, props: ok ? props : null };
  }

  // ── FETCH & RENDER CART ─────────────────────────────
  function refreshCart(){
    var seq = ++cartSeq;
    return fetch('/cart.js',{headers:{'Accept':'application/json'},cache:'no-store'})
      .then(function(r){return r.json()})
      .then(function(cart){ if(seq === cartSeq) renderCart(cart); return cart; })
      .catch(function(){});
  }

  var lastCartCount = null;

  function renderCart(cart){
    var count = cart.item_count || 0;
    document.querySelectorAll('.cart-count').forEach(function(el){
      el.textContent = count;
      el.classList.toggle('is-zero', count === 0);
      if(lastCartCount !== null && count !== lastCartCount){
        el.classList.remove('pop');
        void el.offsetWidth;
        el.classList.add('pop');
      }
    });
    lastCartCount = count;

    var totalEl = document.getElementById('cartTotal');
    if(totalEl) totalEl.textContent = money(itemsTotal(cart));

    updateShipBar(cart);
    renderShipLine(cart);
    renderUpsell(cart);

    var itemsEl = document.getElementById('cartItems');
    if(!itemsEl) return;

    if(!cart.items || !cart.items.length){
      itemsEl.innerHTML = '<div class="cart-empty">' +
        '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" opacity="0.3"><path d="M6 2L3 7V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7l-3-5"/><path d="M3 7h18"/><path d="M9 11v2a3 3 0 0 0 6 0v-2"/></svg>' +
        '<div class="cart-empty-text">YOUR BAG IS EMPTY</div>' +
        '<a href="/collections/all" class="btn-g" data-cart-close>Start Shopping</a>' +
      '</div>';
      return;
    }

    itemsEl.innerHTML = cart.items.map(function(i){
      var key = esc(i.key);
      var variantLabel = (i.variant_title && i.variant_title !== 'Default Title')
        ? '<div class="ci-var">'+esc(i.variant_title)+'</div>' : '';
      var unitLine = i.quantity > 1
        ? '<div class="ci-unit">'+money(i.final_price)+' each</div>' : '';

      // Bundle picks come through as line item properties — show them so the
      // customer can see what they configured before they check out.
      var propsLine = '';
      if(i.properties){
        var rows = [];
        for(var k in i.properties){
          if(!i.properties.hasOwnProperty(k)) continue;
          if(k.charAt(0) === '_' || !i.properties[k]) continue;
          rows.push('<li><span>'+esc(k)+'</span>'+esc(i.properties[k])+'</li>');
        }
        if(rows.length) propsLine = '<ul class="ci-props">'+rows.join('')+'</ul>';
      }

      return '<div class="cart-item" data-key="'+key+'">'+
        '<img class="ci-img" src="'+(i.image ? esc(i.image.replace(/(\.[^.]*)$/,'_160x$1')) : '')+'" alt="'+esc(i.product_title)+'">'+
        '<div class="ci-info">'+
          '<div class="ci-name">'+esc(i.product_title)+'</div>'+
          variantLabel+
          propsLine+
          '<div class="ci-price">'+money(i.final_line_price)+'</div>'+
          unitLine+
          '<div class="ci-qty">'+
            '<button class="ci-qbtn" data-qty-set="'+(i.quantity-1)+'" data-key="'+key+'" '+(i.quantity<=1?'disabled':'')+' aria-label="Decrease quantity">−</button>'+
            '<span class="ci-qv">'+i.quantity+'</span>'+
            '<button class="ci-qbtn" data-qty-set="'+(i.quantity+1)+'" data-key="'+key+'" aria-label="Increase quantity">+</button>'+
          '</div>'+
        '</div>'+
        '<button class="ci-remove" data-key="'+key+'" aria-label="Remove item">✕</button>'+
      '</div>';
    }).join('');
  }

  // ── FREE DELIVERY PROGRESS BAR ────────────────────────
  function updateShipBar(cart){
    var bar = document.getElementById('shipBar');
    if(!bar) return;
    var threshold = parseInt(bar.dataset.threshold, 10) * 100;
    if(!threshold || threshold <= 0 || !cart.item_count){ bar.hidden = true; return; }
    bar.hidden = false;
    var label = document.getElementById('shipBarLabel');
    var fill = document.getElementById('shipBarFill');
    var sub = itemsTotal(cart);
    var remaining = threshold - sub;
    var pct = Math.min(100, Math.round(sub / threshold * 100));
    if(fill) fill.style.width = pct + '%';
    if(!label) return;
    if(remaining > 0){
      label.innerHTML = 'Add <strong>' + money(remaining) + '</strong> for free delivery';
      if(fill) fill.classList.remove('done');
    } else {
      label.textContent = 'Free delivery unlocked';
      if(fill) fill.classList.add('done');
    }
  }

  // ── DELIVERY COST LINE IN THE CART FOOTER ────────────────
  function renderShipLine(cart){
    var el = document.getElementById('cartShipLine');
    if(!el) return;
    var bar = document.getElementById('shipBar');
    var thr = bar ? (parseInt(bar.dataset.threshold, 10) || 0) * 100 : 0;
    var rate = bar ? (parseInt(bar.dataset.rate, 10) || 150) : 150;
    if(!cart.item_count){ el.textContent = ''; return; }
    el.textContent = (thr && itemsTotal(cart) >= thr)
      ? 'Delivery — free'
      : 'Delivery — ' + rate + ' EGP, added at checkout';
  }

  // ── CART UPSELL ───────────────────────────────────
  var upsellCache = { pid: null, products: null };

  function renderUpsell(cart){
    var box = document.getElementById('cartUpsell');
    if(!box) return;
    if(!cart.items || !cart.items.length){ box.hidden = true; box.innerHTML = ''; return; }
    var basePid = cart.items[0].product_id;
    var inCart = cart.items.map(function(i){ return i.product_id; });

    function draw(products){
      var pick = null;
      for(var i = 0; i < products.length; i++){
        var p = products[i];
        // Never upsell a bundle here — bundles must be configured on their own page.
        if(p.type === 'Bundles') continue;
        if(inCart.indexOf(p.id) === -1 && p.available){ pick = p; break; }
      }
      if(!pick){ box.hidden = true; box.innerHTML = ''; return; }
      var v = null;
      for(var j = 0; j < pick.variants.length; j++){
        if(pick.variants[j].available){ v = pick.variants[j]; break; }
      }
      var img = pick.featured_image || (pick.images && pick.images[0]) || '';
      var action = (v && pick.variants.length === 1)
        ? '<button class="upsell-add" data-quick-add="' + v.id + '">+ Add</button>'
        : '<a href="' + esc(pick.url) + '" class="upsell-add" data-cart-close>View</a>';
      box.hidden = false;
      box.innerHTML = '<div class="upsell-tag">Complete the setup</div>' +
        '<div class="upsell-row">' +
          '<a href="' + esc(pick.url) + '" class="upsell-img" data-cart-close><img src="' + esc(img) + '" alt=""></a>' +
          '<div class="upsell-info">' +
            '<a href="' + esc(pick.url) + '" class="upsell-name" data-cart-close>' + esc(pick.title) + '</a>' +
            '<div class="upsell-price">' + money(pick.price) + '</div>' +
          '</div>' +
          action +
        '</div>';
    }

    if(upsellCache.pid === basePid && upsellCache.products){ draw(upsellCache.products); return; }
    fetch('/recommendations/products.json?product_id=' + basePid + '&limit=6')
      .then(function(r){ return r.ok ? r.json() : { products: [] }; })
      .then(function(d){
        upsellCache = { pid: basePid, products: d.products || [] };
        draw(upsellCache.products);
      })
      .catch(function(){ box.hidden = true; });
  }

  // ── ADD TO CART ──────────────────────────────────
  function addToCart(variantId, qty, cb, properties){
    if(cartBusy){ if(cb) cb(false); return; }
    setBusy(true);
    var item = { id: parseInt(variantId,10), quantity: qty||1 };
    if(properties && Object.keys(properties).length) item.properties = properties;
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:[item]})
    })
    .then(function(r){
      if(!r.ok) return r.json().then(function(e){throw e});
      return r.json();
    })
    .then(function(){ setBusy(false); refreshCart(); if(cb) cb(true); })
    .catch(function(err){
      setBusy(false);
      notify(err && err.description ? err.description : 'Could not add to bag');
      refreshCart();
      if(cb) cb(false);
    });
  }

  // ── CHANGE A LINE'S QUANTITY (0 removes it) ────────────────
  function setQuantity(key, quantity){
    if(cartBusy) return;
    quantity = Math.max(0, parseInt(quantity, 10) || 0);
    setBusy(true);
    var seq = ++cartSeq;
    fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(r){
      return r.json().then(function(data){ return { ok: r.ok, data: data }; });
    })
    .then(function(res){
      setBusy(false);
      if(!res.ok){
        notify((res.data && res.data.description) || 'That quantity is not available');
        return refreshCart();
      }
      if(seq === cartSeq) renderCart(res.data);
      var line = (res.data.items || []).filter(function(i){ return i.key === key; })[0];
      if(quantity > 0 && line && line.quantity < quantity){
        notify('Only ' + line.quantity + ' available');
      } else if(quantity === 0){
        notify('Removed from bag');
      }
    })
    .catch(function(){
      setBusy(false);
      notify('Could not update the bag');
      refreshCart();
    });
  }

  // ── CART DRAWER ──────────────────────────────────
  function toggleCart(open){
    var ov = document.getElementById('cartOverlay');
    var dr = document.getElementById('cartDrawer');
    if(!ov||!dr) return;
    var willOpen = (open===undefined) ? !dr.classList.contains('open') : open;
    ov.classList.toggle('open', willOpen);
    dr.classList.toggle('open', willOpen);
    if(willOpen) refreshCart();
  }

  // ── AFTER ADDING: fly to the bag, then drawer (product page) or sticker toast ──
  function afterAdd(src, openDrawer){
    var M = window.SD77;
    if(M && M.fly){
      M.fly(src, function(info){
        if(openDrawer || !M.toast) toggleCart(true);
        else { refreshCart(); M.toast(info); }
      });
    } else {
      toggleCart(true);
      notify('Added to bag');
    }
  }

  window.SD = {
    add: function(id, qty, cb, props){ addToCart(id, qty, cb, props); },
    open: function(){ toggleCart(true); },
    refresh: refreshCart,
    notify: notify
  };

  // ── MOBILE NAV ───────────────────────────────────
  function toggleMobileNav(open){
    var mn = document.getElementById('mobileNav');
    var ov = document.getElementById('sidebarOverlay');
    var burger = document.querySelector('.nav-burger');
    if(!mn) return;
    var willOpen = (open===undefined) ? !mn.classList.contains('open') : open;
    mn.classList.toggle('open', willOpen);
    if(ov) ov.classList.toggle('open', willOpen);
    if(burger) burger.classList.toggle('open', willOpen);
  }

  // ── EVENT DELEGATION ─────────────────────────────
  document.addEventListener('click', function(e){
    if(e.target.closest('[data-cart-toggle]')){ e.preventDefault(); toggleCart(true); return; }
    if(e.target.closest('[data-cart-close]') || e.target.id==='cartOverlay'){ toggleCart(false); return; }

    var qb = e.target.closest('[data-qty-set]');
    if(qb){
      e.preventDefault();
      if(qb.disabled) return;
      setQuantity(qb.dataset.key, qb.dataset.qtySet);
      return;
    }

    var rm = e.target.closest('.ci-remove');
    if(rm){ e.preventDefault(); setQuantity(rm.dataset.key, 0); return; }

    if(e.target.closest('[data-burger]')){ toggleMobileNav(true); return; }
    if(e.target.closest('[data-mnav-close]')){ toggleMobileNav(false); return; }

    // buy now — add current selection, go straight to checkout
    var bn = e.target.closest('#ppBuyNow');
    if(bn){
      e.preventDefault();
      var bundle = collectBundleProps();
      if(!bundle.ok) return;
      var vidEl = document.getElementById('ppVariantId');
      var qEl = document.getElementById('ppQty');
      var q = qEl ? parseInt(qEl.textContent,10) || 1 : 1;
      if(!vidEl) return;
      bn.disabled = true;
      bn.textContent = 'Taking you to checkout…';
      addToCart(vidEl.value, q, function(ok){
        if(ok){ window.location.href = '/checkout'; }
        else { bn.disabled = false; bn.textContent = 'Buy It Now'; }
      }, bundle.props);
      return;
    }

    var qa = e.target.closest('[data-quick-add]');
    if(qa){
      e.preventDefault();
      var vid = qa.dataset.quickAdd;
      if(!vid){ return; }
      addToCart(vid,1,function(ok){ if(ok){ afterAdd(qa, false); } });
      return;
    }

    var aa = e.target.closest('[data-add-all]');
    if(aa){
      e.preventDefault();
      if(cartBusy) return;
      var ids = aa.dataset.addAll.split(',').filter(Boolean);
      var items = ids.map(function(id){ return {id: parseInt(id,10), quantity: 1}; });
      if(!items.length){ return; }
      setBusy(true);
      fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({items: items})
      })
      .then(function(r){ return r.json(); })
      .then(function(){ setBusy(false); refreshCart(); toggleCart(true); notify(items.length + ' items added to bag'); })
      .catch(function(){ setBusy(false); notify('Could not add all items'); refreshCart(); });
      return;
    }
  });

  // ── RECENTLY VIEWED PRODUCTS ────────────────────────
  var RECENT_KEY = 'sd_recently_viewed';

  function trackRecentlyViewed(handle){
    if(!handle) return;
    try{
      var list = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      list = list.filter(function(h){ return h !== handle; });
      list.unshift(handle);
      list = list.slice(0, 8);
      localStorage.setItem(RECENT_KEY, JSON.stringify(list));
    }catch(e){}
  }

  function getRecentlyViewed(excludeHandle){
    try{
      var list = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      return list.filter(function(h){ return h !== excludeHandle; });
    }catch(e){ return []; }
  }

  function renderRecentlyViewed(){
    var el = document.getElementById('recentlyViewed');
    if(!el) return;
    var current = el.dataset.currentHandle || '';
    var handles = getRecentlyViewed(current).slice(0, 4);
    if(!handles.length){ el.closest('.recently-viewed-sec') && (el.closest('.recently-viewed-sec').style.display = 'none'); return; }

    Promise.all(handles.map(function(h){
      return fetch('/products/' + h + '.js').then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; });
    })).then(function(products){
      products = products.filter(Boolean);
      if(!products.length){ el.closest('.recently-viewed-sec') && (el.closest('.recently-viewed-sec').style.display = 'none'); return; }
      el.innerHTML = products.map(function(p){
        var img = p.featured_image || (p.images && p.images[0]) || '';
        var price = (p.price/100).toLocaleString();
        return '<a href="'+esc(p.url)+'" class="pcard">'+
          '<div class="pcard-img"><img src="'+esc(img)+'" alt="'+esc(p.title)+'" loading="lazy">'+
            '<div class="pcard-overlay">'+
              '<div class="pcard-cat">'+esc(p.type||'')+'</div>'+
              '<div class="pcard-name">'+esc(p.title)+'</div>'+
              '<div class="pcard-price"><span>'+price+'</span> EGP</div>'+
            '</div>'+
          '</div>'+
        '</a>';
      }).join('');
    });
  }

  function renderStockBadge(productData, v){
    var el = document.getElementById('stockBadge');
    if(!el) return;
    if(!v || !v.available){
      el.className = 'stock-badge stock-out';
      el.innerHTML = 'Sold Out — DM us to check restock';
      return;
    }
    var threshold = productData.lowStockThreshold || 5;
    var isTracked = !!v.inventoryTracked;
    if(isTracked && v.inventoryQty > 0 && v.inventoryQty <= threshold){
      el.className = 'stock-badge stock-low';
      el.innerHTML = 'Low stock — only <strong>'+v.inventoryQty+'</strong> left';
    } else {
      el.className = 'stock-badge stock-ok';
      el.innerHTML = 'In Stock — '+(productData.deliveryPromise || 'Ships within 1-3 business days');
    }
  }

  function initProductPage(){
    var form = document.getElementById('ppForm');
    if(!form) return;
    var productData = window.__PRODUCT__;
    if(!productData) return;

    var qty = 1;
    var selectedOptions = {};
    var current = productData.variants.find(function(v){return v.available}) || productData.variants[0];
    if(current){
      productData.options.forEach(function(opt, idx){
        selectedOptions[opt] = current.options[idx];
      });
    }

    // clear the error highlight as soon as a slot is chosen
    bundleSelects().forEach(function(sel){
      sel.addEventListener('change', function(){
        if(sel.value) sel.classList.remove('bslot-error');
      });
    });

    function findVariant(){
      return productData.variants.find(function(v){
        return productData.options.every(function(opt, idx){
          return v.options[idx] === selectedOptions[opt];
        });
      });
    }

    function updateUI(){
      var v = findVariant();
      var priceEl = document.getElementById('ppPrice');
      var atc = document.getElementById('ppAtc');
      var atcLabel = atc ? atc.querySelector('.btn-atc-label') : null;
      var vidInput = document.getElementById('ppVariantId');
      var stickyPrice = document.getElementById('stickyPrice');
      var stickyBtn = document.getElementById('stickyAtcBtn');
      var buyNow = document.getElementById('ppBuyNow');
      if(v){
        priceEl.textContent = money(v.price);
        if(stickyPrice) stickyPrice.textContent = money(v.price);
        vidInput.value = v.id;
        if(v.available){
          atc.disabled = false; if(atcLabel) atcLabel.textContent = 'Add to Bag';
          if(stickyBtn){ stickyBtn.disabled = false; stickyBtn.textContent = 'Add to Bag'; }
          if(buyNow){ buyNow.disabled = false; buyNow.textContent = 'Buy It Now'; }
        } else {
          atc.disabled = true; if(atcLabel) atcLabel.textContent = 'Sold Out';
          if(stickyBtn){ stickyBtn.disabled = true; stickyBtn.textContent = 'Sold Out'; }
          if(buyNow){ buyNow.disabled = true; buyNow.textContent = 'Sold Out'; }
        }
      } else {
        atc.disabled = true; if(atcLabel) atcLabel.textContent = 'Unavailable';
        if(buyNow){ buyNow.disabled = true; }
      }
      renderStockBadge(productData, v);
    }

    form.querySelectorAll('[data-opt]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var optName = btn.dataset.opt;
        var optVal = btn.dataset.val;
        selectedOptions[optName] = optVal;
        form.querySelectorAll('[data-opt="'+optName+'"]').forEach(function(b){ b.classList.remove('active'); });
        btn.classList.add('active');
        var lbl = document.querySelector('[data-opt-label="'+optName+'"]');
        if(lbl) lbl.textContent = optVal;
        updateUI();
      });
    });

    var qtyEl = document.getElementById('ppQty');
    form.querySelectorAll('[data-qty]').forEach(function(b){
      b.addEventListener('click', function(){
        qty = Math.max(1, qty + parseInt(b.dataset.qty,10));
        if(qtyEl) qtyEl.textContent = qty;
      });
    });

    function flashAdded(btn){
      if(!btn) return;
      var label = btn.querySelector('.btn-atc-label');
      var original = label ? label.textContent : btn.textContent;
      btn.classList.add('atc-success');
      if(label) label.textContent = 'Added'; else btn.textContent = 'Added';
      setTimeout(function(){
        btn.classList.remove('atc-success');
        if(label) label.textContent = original; else btn.textContent = original;
      }, 1300);
    }

    form.addEventListener('submit', function(e){
      e.preventDefault();
      var bundle = collectBundleProps();
      if(!bundle.ok) return;
      var vid = document.getElementById('ppVariantId').value;
      addToCart(vid, qty, function(ok){
        if(ok){ flashAdded(document.getElementById('ppAtc')); afterAdd(document.getElementById('ppAtc'), true); }
      }, bundle.props);
    });

    var stickyBtnEl = document.getElementById('stickyAtcBtn');
    if(stickyBtnEl){
      stickyBtnEl.addEventListener('click', function(){
        if(stickyBtnEl.disabled) return;
        var bundle = collectBundleProps();
        if(!bundle.ok) return;
        var vid = document.getElementById('ppVariantId').value;
        addToCart(vid, qty, function(ok){
          if(ok){ flashAdded(stickyBtnEl); afterAdd(stickyBtnEl, true); }
        }, bundle.props);
      });
    }

    var atcRow = document.querySelector('.atc-row');
    var stickyBar = document.getElementById('stickyAtc');
    if(atcRow && stickyBar && 'IntersectionObserver' in window){
      var stickyObs = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          stickyBar.classList.toggle('show', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      stickyObs.observe(atcRow);
    }

    var scrollEl = document.getElementById('ppMainScroll');
    var slides = scrollEl ? Array.prototype.slice.call(scrollEl.querySelectorAll('.pp-slide')) : [];
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.pp-thumb'));
    var dots = Array.prototype.slice.call(document.querySelectorAll('.pp-dot'));
    var currentSlideIndex = 0;

    function setActiveSlide(idx){
      currentSlideIndex = idx;
      thumbs.forEach(function(t){ t.classList.toggle('active', parseInt(t.dataset.index,10) === idx); });
      dots.forEach(function(d){ d.classList.toggle('active', parseInt(d.dataset.index,10) === idx); });
    }

    function scrollToSlide(idx){
      var slide = slides[idx];
      if(slide && scrollEl) scrollEl.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      setActiveSlide(idx);
    }

    thumbs.forEach(function(t){
      t.addEventListener('click', function(){ scrollToSlide(parseInt(t.dataset.index,10)); });
    });
    dots.forEach(function(d){
      d.addEventListener('click', function(){ scrollToSlide(parseInt(d.dataset.index,10)); });
    });

    if(scrollEl && slides.length > 1){
      var scrollTimeout;
      scrollEl.addEventListener('scroll', function(){
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function(){
          var scrollLeft = scrollEl.scrollLeft;
          var closest = 0, closestDist = Infinity;
          slides.forEach(function(s, i){
            var dist = Math.abs(s.offsetLeft - scrollLeft);
            if(dist < closestDist){ closestDist = dist; closest = i; }
          });
          setActiveSlide(closest);
        }, 80);
      }, { passive: true });
    }

    var lightbox = document.getElementById('lightbox');
    var lightboxImg = document.getElementById('lightboxImg');
    var lightboxClose = document.getElementById('lightboxClose');
    if(scrollEl && lightbox && lightboxImg){
      scrollEl.addEventListener('click', function(e){
        var slideImg = slides[currentSlideIndex] ? slides[currentSlideIndex].querySelector('img') : null;
        if(!slideImg) return;
        lightboxImg.src = slideImg.dataset.full || slideImg.src;
        lightbox.classList.add('open');
      });
      function closeLightbox(){ lightbox.classList.remove('open'); }
      if(lightboxClose) lightboxClose.addEventListener('click', function(e){ e.stopPropagation(); closeLightbox(); });
      lightbox.addEventListener('click', closeLightbox);
      document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeLightbox(); });
    }

    updateUI();
  }

  // ── COLLECTION FILTER ─────────────────────────────
  function initFilter(){
    var bar = document.getElementById('filterBar');
    if(!bar) return;
    bar.querySelectorAll('.fcat').forEach(function(btn){
      btn.addEventListener('click', function(){
        var cat = btn.dataset.cat;
        bar.querySelectorAll('.fcat').forEach(function(b){b.classList.remove('active')});
        btn.classList.add('active');

        var sections = document.querySelectorAll('#shopGrid .cat-section');
        if(sections.length){
          sections.forEach(function(sec){
            var show = (cat === 'all') || (sec.dataset.catSection === cat);
            sec.style.display = show ? '' : 'none';
          });
        } else {
          document.querySelectorAll('#shopGrid .pcard').forEach(function(card){
            var show = (cat === 'all') || (card.dataset.type === cat);
            card.style.display = show ? '' : 'none';
          });
        }
      });
    });
  }

  // ── SCROLL REVEAL ────────────────────────────────
  function initReveal(){
    var els = document.querySelectorAll('.reveal, .reveal-stagger');
    if(!els.length) return;
    if(!('IntersectionObserver' in window)){
      els.forEach(function(el){ el.classList.add('in'); });
      return;
    }
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('in');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function(el){ obs.observe(el); });
  }

  // ── INIT ──────────────────────────────────────
  function boot(){
    refreshCart();
    initProductPage();
    initFilter();
    initReveal();
    renderRecentlyViewed();
    if(window.__PRODUCT__ && window.__PRODUCT__.handle){
      trackRecentlyViewed(window.__PRODUCT__.handle);
    }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('pageshow', function(e){ if(e.persisted) refreshCart(); });
})();
